import React, { useEffect, useRef } from 'react';
import { useClarity } from '../hooks/useClarity';

const BlogPostWrapper = ({
                             children,
                             title,
                             category,
                             slug,
                         }) => {
    const { trackEvent, setTag, trackBookingClick } = useClarity();
    const startTime = useRef(Date.now());
    const hasTrackedView = useRef(false);

    // Track page view on mount
    useEffect(() => {
        if (!hasTrackedView.current) {
            hasTrackedView.current = true;

            trackEvent('blog_post_viewed', {
                title,
                category,
                slug,
                referrer: document.referrer || 'direct'
            });

            setTag('blog_slug', slug);
            setTag('blog_category', category);
            setTag('page_type', 'blog_post');
        }

        // Track time on page when leaving
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const timeSpent = Math.round((Date.now() - startTime.current) / 1000);
            trackEvent('blog_post_exit', {
                title,
                slug,
                time_spent_seconds: timeSpent,
                time_spent_readable: timeSpent > 60
                    ? `${Math.floor(timeSpent / 60)}m ${timeSpent % 60}s`
                    : `${timeSpent}s`
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Track scroll depth
    useEffect(() => {
        const milestones = [25, 50, 75, 100];
        const tracked = new Set();

        const handleScroll = () => {
            const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
            if (scrollHeight <= 0) return;

            const scrolled = (window.scrollY / scrollHeight) * 100;

            milestones.forEach(milestone => {
                if (scrolled >= milestone && !tracked.has(milestone)) {
                    tracked.add(milestone);
                    trackEvent('blog_scroll_depth', {
                        title,
                        slug,
                        depth: milestone
                    });
                }
            });
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [title, slug, trackEvent]);

    // Intercept CTA clicks
    useEffect(() => {
        const handleClick = (e) => {
            const target = e.target.closest('a, button');
            if (!target) return;

            const href = target.getAttribute('href') || '';

            if (href.includes('cal.com') || href.includes('discovery')) {
                trackBookingClick(`blog-${slug}`);
            }
        };

        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, [slug, trackBookingClick, trackEvent]);

    return <>{children}</>;
};

export default BlogPostWrapper;